import type { ShapedComponent } from '@repo/api-contracts';
import { formatAreaMm } from './format';

const SHAPE_PREFIXES = { ellipse: '원형 ', polygon: '다각형 ' } as const;

/** 인쇄 영역 크기 라벨 — 사각형은 "90 × 90 mm", 원형·다각형은 모양 이름을 앞에 붙인다. 소수는 첫째 자리까지 보인다. */
export const componentSizeLabel = (component: ShapedComponent): string =>
  `${component.shape ? SHAPE_PREFIXES[component.shape.type] : ''}${formatAreaMm(component.widthMm)} × ${formatAreaMm(component.heightMm)} mm`;
